import { useEffect } from 'react';
import { ReactSession } from 'react-client-session';
import { useParams } from "react-router-dom";

function Ref() {
  const { refaddr } = useParams();

  const isAddress = (address) => {
    const re = /^0x[a-fA-F0-9]{40}$/;
    return re.test(address);
  };

  if (!isAddress(refaddr)) {
    ReactSession.set("refwallet", "0x0000000000000000000000000000000000000000");
  } else if (refaddr === '0x000000000000000000000000000000000000dEaD') {
    ReactSession.set("refwallet", "0x0000000000000000000000000000000000000000");
  } else {
    ReactSession.set("refwallet", refaddr);
  }

  useEffect(() => {
    window.location.href = 'https://presalex.site/';
  }, []); 

  return null; 
}

export default Ref;
